import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'x_teacher_notes'
// const DOMAIN = { }

// const BASIC_FIELDS = ['display_name', 'parent_id', 'is_company', 'child_ids']
const BASIC_FIELDS = []
const OPTS = { limit: 50 }

export class PeriodTeacherNotesService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async list (domain = {}, opts = {}) {
    try {
      return await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, { ...OPTS, ...opts })
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async create (data) {
    try {
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async execute (method, params) {
    try {
      console.log(method, params)
      return await this.kwExecute(MODEL, method, params)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
